<template>
  <div class="goIndex" v-loading="loading">
  </div>
</template>

<script>
export default {
  components:{
  },
  data(){
    return{
      loading: true
    }
  },
  created(){
    this.login()
  },
  mounted() {
  },
  methods:{
    login() {
      let form = {
        username: 'hwadmin',
        pwd: md5(111111),
        rememberMe: true,
      }
      this.request.post("/front/auth/login", form).then((rs) => {
        if (rs.code == 200) {
          let privileges = rs.data.privileges
          
          this.storage.setSession("orgName", rs.data.orgName);
          this.storage.setSession("orgId", rs.data.orgId);

          this.storage.setSession("userId", rs.data.userId);
          this.storage.setSession("headImg", rs.data.headImg);
          sessionStorage.setItem("privileges", privileges);
          this.storage.setSession("login", true);
          this.storage.setSession("rememberMe", true);

          this.storage.setSession("loginName", rs.data.loginName);
          this.storage.setSession("nickName", rs.data.nickName);
          this.storage.setSession("tenant", rs.data.tenant);
          this.storage.setSession("isMaxTenant", rs.data.isMaxTenant);

          // 跳转至首页
          // privileges.indexOf('home:show') != -1
          if(rs.data.tenant) {
            this.$router.push('/screen') // 大屏
          } else {
            this.$router.push('/equipmentM') // 首页
          }
        } else if (rs.code == 500) {
          console.log('登录失败')
        } else if (rs.code == 1000) {
          console.log('登录失败')
        }
      })
      .catch((error) => {
        console.log(error);
      });

    },
  },
}
</script>

<style lang="scss" scoped>
.goIndex{
  width: 100%;
  height: 100%;
}
</style>
